<template>
  <div id="singleFormView" class="row">
  <div class="spinner-dialog" v-if="loading" :data-message="`Loading Please wait`">
    <div class="progress">
        <div class="indeterminate"></div>
    </div>
  </div>
    <div class="col s12 l10 no-float center-aligned" v-if="ready">
      <div class="col s12 l8 no-float center-aligned input-field" v-if="step === 0">
        <div class="card">
          <div class="card-content">
            
            <div class="col s12 no-padding">
              <div class="country-selection">
                Please select Country you are submitting data for:
              </div>
            </div>
            <select class="browser-default" v-model="postCountry">
              <option
              :disabled="canSelect(key)"
              v-for="(country, key, index) in countries" :value="key" :key="index">{{country}}</option>
            </select>
            <div class="col s12 input-field no-padding center">
              <button class="btn waves-effect rounded" style="width:180px" @click="step = 1" :disabled="postCountry === ''">Proceed</button>
            </div>
            <div class="clear"></div>

          </div>
        </div>
      </div>
      <div class="col s12">
        <ul class="no-padding" style="border-bottom: 1px solid silver; padding-bottom: 20px !important;" v-if="post && post.acf && post.acf.period">
          <li style="font-size: 18px; font-weight:600; margin-bottom:8px; font-famliy:'Libre Franklin'">
            {{post.acf.period.term.replaceAll('0', '')}} 
          </li>
          <li style="font-size: 18px; font-weight:600; margin-bottom:8px; font-famliy:'Libre Franklin'">
            {{post.acf.country.label }}
          </li>
          <li v-if="post && createdFor" style="font-size: 18px; font-weight:600; margin-bottom:8px; font-famliy:'Libre Franklin'">
            <span v-html="createdFor.name"></span>
          </li>
      <!--     <li>
            <span class="chip"><i class="material-icons-outlined grey-text text-darken-4 action left">today</i> From: {{post.acf.period.date_from}} </span>
            <span class="chip"><i class="material-icons-outlined grey-text text-darken-4 action left">today</i> To: {{post.acf.period.date_to}} </span>
          </li> -->
        </ul>
      </div>
    <div class="form-fields" :class="`a${form.resource_id}`" v-if="step === 1">

    <span style="display:none;" >
      <section ref="ps" style="padding: 16px 24px 16px 24px;  font-size: 12px; line-height: 1.2; font-family:Aria,'Roboto', sans-serif; width: 600px"  >
   
      </section>
    </span>
    <div v-if="!printView">
      <div 
        :class="field.layout"
        v-for="(field, index) in form.fields" v-bind:key="index">
        <field-types
        @action="$_helpers"
          :global-disabled="!editMode"
          @update="$_populate"
          :data-option="field">
        </field-types>
      </div>
    </div>
    
    </div>
    <div class="clear"></div>
  <div class="edit-bar" >
    <div class="col s12 l12 no-float center-aligned flex-row">
      <div class="col">
      <router-link :to="{path:'/stats'}">
          <button class="btn-floating btn-flat waves-effect">
          <i class="material-icons-outlined grey-text text-darken-4">arrow_back</i>
        </button>
      </router-link>
      </div>
      <div class="col s6 no-padding">
        <span class="edit-bar-title" v-html="currentCategoryName"> </span>
      </div>
      <div class="col no-padding right right-align submit-button">
       <button @click="$_saveData(false)" :disabled="loading || post && post.acf.status !== 'new' || step === 0 || cuttOffDate" class="btn rounded waves-effect" v-text="$route.name === 'statFormView' ? 'Update' : 'Save'"> </button>
      </div> 
      <div class="col right hide-on-small-only" v-if="$route.name === 'statFormView'">
        <button @click="genPdf" v-tipped data-tooltip="Download" class="btn rounded white waves-effect grey-text text-darken-4">
          <i class="material-icons-outlined grey-text text-darken-4 left">download</i> Download
        </button>
      </div>
      <div class="col  right" :class="$route.name === 'statFormView' ? 'no-padding' : ''">
        <button @click="modalInstance.open()" v-tipped data-tooltip="View Instructions" class="btn  white blue-text text-accent-4 waves-effect rounded">
          <i class="material-icons-outlined blue-text text-accent-4 left">live_help</i>Instructions
        </button>
      </div>
      <div class="clear"></div>
    </div>
  </div>
      <div class="col s12 center" style="margin-top:24px;"  v-if="post">
        <!-- <button @click="$_saveData('completed')"  -->
        <button @click="$submitDialog"  
        :disabled="$route.name !== 'statFormView' || loading || !editMode"
        style="width:200px"
        class="btn-large rounded waves-effect"> Final Submission</button>
      </div>
    </div>
    
     <div class="modal modal-fixed-footer fm" ref="modal">
      <div class="modal-header white">
        <span v-html="currentCategoryName"></span>
      <button class="btn-flat modal-close right btn-floating waves-effect">
        <i class="material-icons grey-text text-darken-3">close</i>
      </button>
      </div>
      <div class="modal-content white">
        <!-- <div v-html="Number($route.params.categoryId) === 177 ? criminalInstructions :  civilInstructions "></div> -->
        <div class="content" v-html="currentCategory.instructions"></div>
      </div>
   </div>
   <appSupport :data-form="currentCategoryName" :submission="post" :data-user="userProfile"/>
  </div>
</template>
<script>
/* const dropReactivity = (value) => {
  return JSON.parse(JSON.stringify(value));
}; */
function isJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

import  { jsPDF } from "jspdf";
import moment from 'moment'
import appSupport from '@/components/floatSupport.component.vue'
import {mapState} from 'vuex'
import {content, criminal} from './instructions.js'
import {nanoid} from 'nanoid'
import {toastMessage, updateFields, initModal} from '@/functions.js'
import {formMailService} from '@/services/apiService.js'
import {updateSubmission, fetchSubmission, getAppUsers} from '@/services/contentService.js'
import fields from './criminalForm.js'
import {newCriminal, newCivil} from './NewForm.js'
import civil from './civilForm.js'
import fieldTypes from '@/components/records/fieldTypes.component' // records form is original template
export default {
  name: "singleFormView",
  props:{
    userProfile: {
      type: Object
    },
    dataAlready:{
      type: Array
    },
    dataCategories:{
      type: Array,
    }
  },
  components: {
    fieldTypes,
    appSupport
  },
  watch:{
    "currentCategoryName": function (nV) {
      window.console.log(nV)
    }
  },
  data () {
    return {
      temp:false,
      step: 0,
      newCriminal,
      printView: false,
      newCivil,
      pdfDownloadable:false,
      modalInstance: null,
      modalOptions:{
      },
      civilInstructions: content,
      criminalInstructions: criminal,
      postCountry:'',
      countries:{
        "anguilla" : "Anguilla",
        "antigua" : "Antigua",
        "dominica" : "Dominica ",
        "grenada ":" Grenada",
        "nevis": "Nevis",
        "montserrat" : "Montserrat",
        "st. kitts" : "St. Kitts",
        "saint lucia" :"Saint Lucia",
        "st. vincent" : "St. Vincent",
        "bvi" : "Territory of the virgin islands",
      },
      post: false,
      loading: true,
      isActive: false,
      ready: false,
    /*  ...fields, */
      form:{
        resource_id: 0
      },
     civilForm: {
       resource_id: 178,
      ...civil
     },
     criminalForm:{
       resource_id:177,
       ...fields
     },
     toSubmitRaw: {}
    }
  },
  created () {
    if(this.criminalForm.resource_id === parseInt(this.$route.params.categoryId)) {
      
        this.form = {...this.criminalForm}
        this.form.fields.forEach((field)=>{ 
          if(field.values && field.type !== 'data_table') field.values = ""
          else if(field.values) {
            field.values.forEach((field => {
              field.total = 0
            }))
          }
        })
        /* this.form.fields = this.criminalForm.generate() */
      } else {
        this.form = {...this.civilForm}
        this.form.fields.forEach((field)=>{ 
          if(field.values && field.type !== 'data_table') field.values = ""
          else if(field.values) {
            field.values.forEach((field => {
              field.total = 0
            }))
          }  
          
        })
        /* this.form.fields = this.civilForm.generate() */
      }
  },
  async mounted () {
  /*   this.fields =  */
    this._initModal()
    await this.getAppUsers()
    if(this.$route.name === 'statFormView') {
      this.step = 1
      let {data} = await fetchSubmission(this.$route.params.id)
      this.post = data
      if(data.acf.formfields) {
        let dataObj = { }
        data.acf.formfields.forEach((field) => {
          dataObj[field.key] =  !isJsonString(field.value) ? field.value : JSON.parse(field.value)
        })
         this.form.populate(dataObj)
         this.toSubmitRaw = dataObj
        //window.console.log(dataObj)
      }
      else if(data.acf.json_string !== '') {
        return
        this.form.populate(JSON.parse(data.acf.json_string))
        let oldValues = {}
        this.form.fields.filter(x => x.type !== 'label')
        .forEach(y => {
          oldValues[y.name] = y.values
          this.toSubmitRaw = oldValues
        })
      }
 
     setTimeout(()=> {
        this.ready = true
        this.loading = false
     })
     
      setTimeout(() => {
          this.pdfDownloadable = true
      },1000);

    } else {
      this.form.fields.filter(x => x.type !== 'label' && x.type !== 'data_table').forEach(x => x.values = "")
      setTimeout(()=> {
        this.ready = true
        this.loading = false
     })
    }
    
     setTimeout(() => {
        updateFields()
     }, 400);
  },
  computed :{
    ...mapState({
        user: state => state.user,
        staff: state => state.staff,
    }),
    createdFor () {
      return this.staff.find(({id})=> id === this.post.author) 
    },
    cuttOffDate () {
     // if( moment(new Date()).isAfter(moment(new Date(this.currentCategory.cut_of_date)))) return true
      return false
    },
    editMode () {
      if(this.cuttOffDate) return false
      if(this.$route.name === 'statFormNew') return true
      if(this.$route.query.view === 'no-edit') return false
      if ( this.post && this.post.acf.status === 'new')return true
      return false
    },
     currentCategoryId(){
      let record =  this.dataCategories.find(({id}) => id === parseInt(this.$route.params.categoryId))
        if(record) {
          return record.id
        } else {
          return {}
        }
    },
    currentCategoryName(){
      let record =  this.dataCategories.find(({id}) => id === parseInt(this.$route.params.categoryId))
        if(record) {
          return record.name
        } else {
          return ''
        }
    },
    currentCategory () {
        let record =  this.dataCategories.find(({id}) => id === parseInt(this.$route.params.categoryId))
        if(record) {
          return {
            ...record.acf.period__term, 
            cut_of_date: record.acf.cut_of_date, 
            instructions: record.acf.instructions ? record.acf.instructions : ''}
        } else {
          return {}
        }
    },
    allResponses () {
      if(this.loading) return false
       return  Object.keys(this.toSubmitRaw).map((key) => {
        let l = this.form.fields.find((field) => field.name === `${key}_label`)
        let x = {
          label: l && l.label ? l.label : false,
          key,
          value: typeof this.toSubmitRaw[key] === "string"  ? this.toSubmitRaw[key] : JSON.stringify(this.toSubmitRaw[key])
        }
        return x 
      })

    }
  },
  methods:{
    genPdf () {
      this.$refs.ps.innerHTML  = this.$_renderContent()
   
        let pdf = new jsPDF('p', 'pt', 'letter');
        let vm = this
        let source = this.$refs.ps
      let specialElementHandlers = {
            '#bypassme': function (/* element, renderer */) {
                // true = "handled elsewhere, bypass text extraction"
                return true
            }
        };
        let margins = {
            top: 80,
            bottom: 60,
            left: 40,
            width: 522
        };
      //  pdf.setFontSize(12)
      pdf.html(
        source, 
        {  
          margins:[80, 40, 80, 40],
          autoPaging: 'text',
          'width': margins.width,
          //'elementHandlers': specialElementHandlers,
            callback:  async () => {
              this.loading = true
              try {                
              let name = `${vm.post.acf.country.label}-${vm.currentCategoryName}-${vm.user.first_name}-${vm.user.last_name}`
              await pdf.save(`${name}.pdf`);
              
              this.loading = false
              }catch(err){
                this.loading = false
               if(err) window.M.toastMessage({html:`Error Generating your download please try again later`})
              }
            }
        })
    },
    _initModal (){
      this.modalInstance = initModal(this.$refs.modal, this.modalOptions)
    },
      async getAppUsers() {
      let {data} = await getAppUsers()
      this.$store.commit('SET_STAFF_LISTS', data)
      return data
    },
    $_renderContent () {
      if(!this.post ||  !this.post.acf ) return ''
      let form = this.form.populate(this.post.acf.formfields)
      return /* html */`<div>${this.user.first_name}-${this.user.last_name}</div>
      <div style="font-weight:500; margin-top: 4px; margin-bottom:12px; font-size:20px">
          ${this.currentCategoryName} 
      </div>
      <div style=" margin-top: 4px; margin-bottom:12px; font-size:24px">
          ${this.post.acf.country.label}
      </div>
   
      ${form.map((field) => {
       if(field.type === 'label' && field.layout.includes('section-title')) return `<div style="font-weight:500; margin-top: 4px; margin-bottom:6px; font-size:20px">${field.label}</div>`
        if(field.type === 'label') return `<span  style="margin-bottom: 8px; display:inline-flex; ${field.layout.includes('sub-indent') ? 'margin-left:28px;' : ''}">${field.label}: </span>`
       if( field.type !== 'label' ) return Array.isArray(field.values) 
       ? `<table style="border: 1px solid #c1c1c1; margin-bottom: 24px; max-width:100%; width: 552px;">
       <thead>
       <tr><th style="padding:10px; border-right:1px solid #c1c1c1">Reason</th><th style="padding:10px;">Total</th><tr>
       </thead>
       <tbody>
       ${field.values.map(x => {
          return `<tr><td style="padding:10px; border-right:1px solid #c1c1c1"> ${x.reason}</td><td style="padding:10px;"> ${x.total} </td></tr>`
        })}
      
       </tbody>
       </table>` : `<span> ${field.values}</span> </br>`
      }).toString().replaceAll(',', '')} 
      `
    },
    $_helpers (v){
      this.modalInstance.open()
      setTimeout(() => {
      document.querySelector(`.modal-content #${v.data}`)
      .scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"})
      }, 500);
  
    },
    generateReport () {
        this.$refs.html2Pdf.generatePdf()
    },
    canSelect (key) {
      let record = this.dataAlready.findIndex(({country}) => country === key)
      if(record > -1 && this.dataAlready[record].category === Number(this.$route.params.categoryId)) return true
      else false
 /*      let one = this.dataAlready.length > 0 && 
      this.dataAlready.map(({country}) => country).includes(key)
      &&  this.dataAlready.map(({category}) => category).includes(Number(this.$route.params.categoryId))
      
      return one */
    },
    $_populate (ev) {
       let key = ev.name ? ev.name : ev.prop ? ev.prop : ev.key
      this.toSubmitRaw[key] = ev.data ? ev.data : ev.value
    },
    async $submitDialog  () {
        let data = {
        title: `Submit Report`,
        message: `Are you sure you want submit your entry?. If you confirm you will no longer have the ability to edit this entry`,
        buttons: [
          {
            id:0, 
            value: 'DISMISS', 
            action:()=>{
							this.$store.commit('CLEAR_DIALOG')
            }, 
            close: true
          },

          {
            id:1, 
            value: 'Confirm', 
            action: async()=>{ 
              
              this.$store.commit('SET_APP_LOADER', {status:true, message:`Processing please wait...`})
              await this.$_saveData('completed')
              this.$store.commit('CLEAR_DIALOG') 
              this.$router.push({path:'/stats'})
            }, 
            close: true
          },
        ],
        dataType: ''
      }
      this.$store.commit('TRIGGER_DIALOG', {data:data})
    },
    async $_saveData (v){
     /*  this.loading = true */
     if(this.cuttOffDate) {
       toastMessage('You can no longer edit this entry')
       return 
      }
     this.temp = true
     if(!v) this.$store.commit('SET_APP_LOADER', {status:true, message:`Saving please wait...`})
      let valueCheck =  Object.keys(this.toSubmitRaw).map((key) => {
        let l = this.form.fields.find((field) => field.name === `${key}_label`)
        let x = {
          label: l && l.label ? l.label : false,
          key,
          value: typeof this.toSubmitRaw[key] === "string"  ? this.toSubmitRaw[key] : JSON.stringify(this.toSubmitRaw[key])
        }
        return x 
      })
   
      if(this.$route.name === 'statFormNew') {
        let payload  = {
          title: `${this.userProfile.slug}${nanoid()}`,
          author: this.userProfile.id,
          content: '',
          categories:[this.$route.params.categoryId],
          status: 'publish',
          fields: {
            country: this.postCountry,
            status: "new",
            period: this.currentCategory,
            //json_string: JSON.stringify(this.toSubmitRaw),
            formfields: valueCheck

          }
        }
        try {
         let {data} = await updateSubmission(false, payload)
          toastMessage('Updated Succesfully')
          this.$store.commit('SET_APP_LOADER', {status:false})
          this.post = data
          this.$emit('data', data)
             this.$router.replace({name:'statFormView', 
              params:{id:data.id, userId: this.userProfile.id, categoryId:this.currentCategoryId
          }})
          this.pdfDownloadable = true
          this.temp = false
          return data
        } catch (err) {
          window.console.log(err)
        }
      } else {
        let payload = {
          fields: {
            //json_string: JSON.stringify(this.toSubmitRaw),
            formfields: this.allResponses
          }
        }
        if(v) payload.fields.status = 'completed'
        try {
          let {data} = await updateSubmission(this.$route.params.id, payload)
         
            this.post = data
            this.$emit('data', data)
            this.$store.commit('SET_APP_LOADER', {status:false})
            toastMessage('Updated Succesfully')
            this.temp = false
           if(v === 'completed') {

              let linesSchema = { }
              this.form.fields.filter(x => x.type !== 'label')
              .forEach((item, index) => {
             //   console.log(item.values, item.label)
                let label = this.form.fields.filter(({type}) => type === 'label')
                            .find(({name}) => name === item.name+'_label')
                linesSchema[`label__${index + 1}`] = `${label ? label.label : ''}`
                if(item.type === 'data_table' && Array.isArray(item.values)) {
                  linesSchema[`value__${index + 1}`] = item.values.map(({reason, total}) => {
                    return `${reason} - ${total}
                    `
                  }).toString().replaceAll(',', '')
                }
                else linesSchema[`value__${index + 1}`] = `${item.values}`
              })
              linesSchema['_wpcf7_groups_count[questions]'] =  this.form.fields.filter(x => x.type &&  x.type !== 'label').length

              let notificationPayload = {
                name: this.userProfile.first_name+' '+this.userProfile.last_name,
                email: this.userProfile.email,
                _wpcf7_unit_tag:"fc7b67b",
                subject:this.userProfile.first_name+' ',
                link: window.location.href,
                ...linesSchema,
              }
              await formMailService(5648, notificationPayload)
             // return data
              }
        } catch (err) {
          window.console.log(err)
        }
      }

    }
  }
}
</script>
<style scoped lang="scss">
#singleFormView {
  padding: 24px !important;
  background: #fafafa;
  min-height: calc(100vh - 140px);
  @media screen and (max-width: 960px) {
    padding: 24px 0px !important;
  }
}
.country-selection {
  font-size: 21px;
  margin-bottom: 8px;
}
.edit-bar-title {
  font-family: "Libre Franklin";
  font-size: 18px;
  font-weight: 500;
  white-space: nowrap;
  display: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 42px;
}
.flex-row {
  display: flow-root;
}
.edit-bar {
  position: fixed;
  top: 56px;
  width: calc(100% - 300px);
  background: #fff;
  padding: 18px;
  left: 300px;  
  z-index: 100;
  border-bottom: 1px solid #f2f2f2;
  @media screen and (max-width: 960px) {
    width: 100%;
    left:0;
    padding: 18px 0px;
    .edit-bar-title {
      display: none;
    }
  }
}
.modal {
  min-height: 90%;
  top: 5% !important;
  max-width: 768px;
  border-radius: 10px;
}
.modal.fm:not(.datepicker) {
  .modal-header {
    height: 50px;
    font-size: 16px;
    line-height: 34px;
    padding: 8px 16px;
    border-bottom: 1px solid #d9d9d9;
  }
  .modal-content {
    height: calc(100% - 106px) !important;
    }
  }
</style>
<style lang="scss">
@media print {
#sideSiteNav, nav, .edit-bar, #floatingSupport, button {
  display: none !important;
}
#singleFormView .form-fields input[type="number"] {
  border: none !important;
}
#singleFormView {
  margin-top: -124px;
}
table {
  page-break-after: always;
}
}
#singleFormView {
  .modal {
  .modal-content {
    height: calc(100% - 106px) !important;
      table {
        border: 1px solid grey !important;
        td {
          border-right: 1px solid rgba(0,0,0,0.8);
          padding: 10px;
          vertical-align: top;
        }
      }
    }
  }
  .section-title {
    font-size: 25px;
    font-family: "Libre Franklin", sans-serif;
    font-weight: 600;
    margin-top: 22px;
    margin-bottom: 12px
  }
  .form-fields {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    font-size: 17px;
    .col {
     &.sub-indent {
        padding-left: 40px;
         
        }
      &.description {
        width: 80%;
        margin-top: 12px;
        margin-bottom: 16px;
        &.drag-line {
          position: relative;
          &.sub-indent {
            padding-left: 40px;
            &::after {
              left: 42px;
            }
          }
          &::after {
            position: absolute;
            content: ' ';
            top: 50%;
            left: 16px;
            right: 0px;
            height: 1px;
            border-top: 1px dashed rgba(0,0,0,0.3);
          }
          .label-field {
            span {
              background: #fafafa;
              z-index: 9;
              padding-right: 8px;
              position: relative;
              display: inline-flex;
            }
          }
        }
      }
      &.number-value {
        width: 20%;
        margin-bottom: 16px;
      }
    }
    &:not(.a178) {
      .input-field {
         margin: 0px;
      }
    }
    &.a178{
      .input-field {
         margin-bottom: 12px;
      }
    }
    /* .input-field { */
      input[type="number"] {
        border: 1px solid rgba(0,0,0,0.3);
        border-radius: 6px;
        padding: 0 12px;
        max-width: calc(100% - 24px);
        background: white;
        min-height: 34px;
        &:focus {
          border: 1px solid #3d5afe !important;
          box-shadow: none !important;
        }
      }
    /* } */
  }
  .input-field > label {
    font-size: 14px;
      &.active {
        transform: translateY(-20px) scale(0.9) !important;
      }
  }
  .label-field {
    &.help-guide {
      display: flex;
      i {
        max-width: 24px !important;
        margin-left: 4px;
        line-height: 38px;
      }
    }
  }

.dataTableField {
  background:white;
  margin: 16px 0 42px !important;
  table {
    td {
      input[type="number"] {
        max-width: 120px !important;
      }
    }
    
    td {
      &.left-option {
        input:not([disabled="disabled"]) {
          border: 1px solid #cecece !important;
          box-shadow: none !important;
          border-radius: 3px !important;
          padding: 0 6px !important;
          width: calc(100% - 22px);
        }
      }
      &.left-option {
        input {
          font-size:16px;
          font-weight: 500;
        }
      }
    }
  }
}
textarea {
  &.materialize-textarea {
    padding: 12px;
    border: 1px solid #d1d1d1 !important;
    border-radius: 8px;
    min-height: 120px;
    background: white;
  }
}
.spinner-dialog {
  width: 60%;
  max-width: 320px;
  position: fixed;
  left:50%;
  top:50%;
  transform: translate(-50%, -50%);
  margin: auto;
  z-index: 99999;
  &::after{
    content:attr(data-message);
    bottom: -10px;
    position: absolute;
    font-size: 12px;
  }
}
}
</style>